module.exports = __webpack_public_path__ + "static/img/mobileBgPic.ca5cbe1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Amdocs/mobileBgPic.png
// module id = 3fXw
// module chunks = 0